<template lang="html">
    <div class="main-form">
        <div class="main-form__logo">
            <img src="@/assets/images/logo.svg" alt="Nexyo Logo">
        </div>
        <div class="main-form__container">
            <div class="main-form__role-button" @click="$router.push('/specialist/login')" v-if="role === 'client'">
                Specialist
                <br>
                Log-In
            </div>
            <div class="main-form__role-button" @click="$router.push('/login')" v-else>
                Client
                <br>
                Log-In
            </div>
            <div class="main-form__title">
                Intră în cont
            </div>
            <div v-if="apiErrors" class="main-form__text">
                <span v-if="typeof apiErrors == 'string'" class="error">
                    {{apiErrors}}<br>
                </span>
                <span v-else-if="typeof apiErrors == 'object'"
                    v-for="error in apiErrors" :key="error" class="error">
                    {{error}}<br>
                </span>
            </div>
            <UiInput
                class="main-form__input"
                label="Adresă de email"
                type="email"
                :placeholder="role === 'client' ? 'user@gmail.com' : 'specialist@gmail.com'"
                :value="email"
                :disabled="isLoading"
                :error="errors.email"
                @input="email = $event, validateEmail()"
                @blur="validateEmail"
                @keyup="loginOnEnter"
            />
            <UiInput
                class="main-form__input"
                label="Parolă"
                type="password"
                :forgotPassword="role === 'client'"
                :forgotPasswordEmail="errors.email === '' ? email : ''"
                :error="errors.password"
                :disabled="isLoading"
                @input="password = $event, validatePassword()"
                @blur="validatePassword"
                @keyup="loginOnEnter"
            />

            <div class="main-form__submit">
                <UiButton
                    shape="square"
                    name="Continuă"
                    :disabled="disabledButton"
                    :name="isLoading ? 'Se incarcă...' : 'Continuă'"
                    @click="sendLogin"
                />
                
                <router-link to="/register" tag="span" v-if="role === 'client'">
                    <div class="main-form__subtext">
                        Nu ai cont? <a>Înregistreaza-te acum!</a>
                    </div>
                </router-link>
            </div>

            <SocialAuth @clearForm="clearForm" v-if="role === 'client'" />

            <router-link to="/login" tag="span" v-if="role === 'specialist'">
                <div class="main-form__subtext">
                    Nu ești specialist? <a @click="role = 'client', apiErrors = null">Mergi la paigina de utilizator!</a>
                </div>
            </router-link>
        </div>
        <div class="main-form__empty"></div>
    </div>
</template>

<script>
import UiInput from '@/components/ui/Input'
import UiButton from '@/components/ui/Button'
import SocialAuth from '@/pages/SocialAuth.vue'

import { mapActions } from 'vuex'

export default {
    components: {
        UiInput,
        UiButton,
        SocialAuth
    },
    data() {
        return {
            role: 'client',
            email: '',
            password: '',
            errors: {
                email: '',
                password: ''
            },
            apiErrors: null,
            isLoading: false
        }
    },
    created() {
        if(this.$router.currentRoute.fullPath == '/specialist/login')
            this.role = 'specialist';
        else
            this.role = 'client';
    },
    methods: {
        ...mapActions({
            login: 'user/login'
        }),
        sendLogin() {
            if(this.disabledButton === false && this.isLoading === false) {
                this.isLoading = true;

                var data = {
                    role: this.role,
                    email: this.email,
                    password: this.password
                }

                this.login(data);
                this.errors.email = '';
                this.errors.password = '';
                this.errors.apiErrors = null;
            }
        },
        loginOnEnter(event) {
            if (event.keyCode === 13) {
                this.sendLogin();
            }
        },
        validateEmailFormat(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        validateEmail() {
            this.apiErrors = null;
            if(this.validateEmailFormat(this.email))
                this.errors.email = '';
            else this.errors.email = 'Adresa de email este incorectă';
        },
        validatePassword() {
            this.apiErrors = null;
            if(this.password.length < 6)
                this.errors.password = 'Parola trebuie să contină minim 6 caractere';
            else {
                this.errors.password = '';
                this.errors.passwordConfirmation = '';
            }
        },
        clearForm() {
            this.email = '';
            this.password = '';
            this.errors.email = '';
            this.errors.password = '';
            this.apiErrors = null;
        }
    },
    computed: {
        disabledButton() {
            if (this.isLoading) return true;

            if (
                this.errors.password === ''
                && this.errors.email === ''
                && (
                    this.email.length > 0
                    && this.password.length > 0
                    && this.role.length > 0
                )
            ) {
                return false;
            }

            return true;
        }
    },
    watch: {
        "$store._modules.root.state.notification.notification.title"(notification) {
            this.isLoading = false;
            this.apiErrors = notification;
		},
        "$route"() {
            if(this.$router.currentRoute.fullPath == '/specialist/login')
                this.role = 'specialist';
            else
                this.role = 'client';
        }
    }
}

</script>
